import { createSystem, defaultConfig, defineConfig } from "@chakra-ui/react";

const config = defineConfig({});

export const system = createSystem(defaultConfig, config);
